import React, { useCallback } from "react";
import { useModal } from "react-modal-hook";
import { useGetAccountDocumentTemplatesForMapLazyQuery } from "../../../generated/graphql";
import Modal from "../../Common/Modal";
import { GenerateDocumentForm } from "../../DocumentUploads/GeneratedDocuments/GenerateDocumentForm";
import { filterPropertyDocumentTemplates, ListObject } from "./utils";

export const useGenerateFromTemplateModal = ({
  object,
  updateMap,
}: {
  object: ListObject;
  updateMap: () => void;
}) => {
  const [getDocumentTemplates, { data }] =
    useGetAccountDocumentTemplatesForMapLazyQuery({
      fetchPolicy: "network-only",
      onCompleted: () => showGenerateFromTemplateModal(),
    });

  const [showGenerateFromTemplateModal, hideGenerateFromTemplateModal] =
    useModal(
      () => (
        <Modal onRequestClose={hideGenerateFromTemplateModal}>
          <GenerateDocumentForm
            object={object}
            documentTemplates={filterPropertyDocumentTemplates(
              object,
              data?.account?.documentTemplates
            )}
            updateMap={updateMap}
            closeModal={() => hideGenerateFromTemplateModal()}
          />
        </Modal>
      ),
      [data, object, updateMap]
    );

  const showModalCallback = useCallback(() => {
    void getDocumentTemplates();
  }, [getDocumentTemplates]);

  return [showModalCallback] as const;
};
